import React, { useState } from "react";

import Header from '@/views/components/Header/Header';
import Footer from '@/views/components/Footer/Footer';
import LetterLogic from '@/views/pages/Letter/LetterLogic';
import LetterHeader from '@/views/pages/Letter/elements/LetterHeader';
import LetterInfo from '@/views/pages/Letter/elements/LetterInfo';
import LetterVersionsWrapper from '@/views/pages/Letter/elements/LetterVersionsWrapper';

import EditLetterWrapper from '@/views/pages/Letter/elements/EditLetterWrapper';

import LetterContextWrapper from '@/views/pages/Letter/elements/LetterContextWrapper';

import FlexWrapper from '@/utils/FlexWrapper';
import ModalMetadataView from "@/views/pages/Letter/modals/ModalMetadataView";

const Letter = () => {
	// const tf = useRef();
	// entire state moved to TextContextWrapper
	const [ currentLeftMode, setCurrentLeftMode ] = useState(null);
	const [ currentRightMode, setCurrentRightMode ] = useState(null);

	return (
		<div className="letter-page">
			<FlexWrapper>
				<Header narrow />
				<LetterContextWrapper>
					<LetterLogic>
						<ModalMetadataView />
						<EditLetterWrapper />
						<LetterHeader
							currentMode={ currentRightMode }
						/>
						<LetterInfo />
						<LetterVersionsWrapper 
							currentLeftMode={ currentLeftMode } 
							setCurrentLeftMode={ setCurrentLeftMode } 
							currentRightMode={ currentRightMode } 
							setCurrentRightMode={ setCurrentRightMode } 
						/>
					</LetterLogic>
				</LetterContextWrapper>
				<Footer 
					narrow 
					className='letter-footer'
				/>
			</FlexWrapper>
		</div>	
	);
};
export default Letter;
